import usePrivateAxios from '@/common/api/usePrivateAxios'
import { defaultTransformerResponse } from '@/common/constants/defaultTransformerResponse.constant'
import { Mapper } from '@/common/services/mapper'
import { MetaResponse } from '@/common/types/metaResponse'
import { keepPreviousData, useQuery } from '@tanstack/react-query'

type UseBillingBillPaymentsProps<T> = {
  filters?: {
    id?: string
    page?: number
  }
  mapper?: (data: any) => T
}

export const useBillingBillPayments = <T,>({
  filters: { id, page = 1 } = {},
  mapper = Mapper.default<T>(),
}: UseBillingBillPaymentsProps<T>) => {
  const privateAxios = usePrivateAxios()

  const { data: { data, meta } = defaultTransformerResponse<T>(), ...rest } = useQuery({
    queryKey: ['billingBillPayments', id, page],
    queryFn: () => {
      return privateAxios.get(`/billing/bills/${id}/payments`, {
        params: {
          page,
        },
      })
    },
    select: (data: { data: { data: any[]; meta: MetaResponse } }) => {
      return {
        data: mapper(data?.data?.data),
        meta: data?.data?.meta,
      }
    },
    placeholderData: keepPreviousData,
  })

  return { data, meta, ...rest }
}
